/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  DocumentResponse,
  FileStreamResult,
  MergeCounselorDocumentsRequest,
  MergeCounselorDocumentsResponse,
  ProblemDetails,
  RenameDocumentRequest,
} from '../models/index';
import {
    DocumentResponseFromJSON,
    DocumentResponseToJSON,
    FileStreamResultFromJSON,
    FileStreamResultToJSON,
    MergeCounselorDocumentsRequestFromJSON,
    MergeCounselorDocumentsRequestToJSON,
    MergeCounselorDocumentsResponseFromJSON,
    MergeCounselorDocumentsResponseToJSON,
    ProblemDetailsFromJSON,
    ProblemDetailsToJSON,
    RenameDocumentRequestFromJSON,
    RenameDocumentRequestToJSON,
} from '../models/index';

export interface ConvertDocumentInCounselorDropZoneToPdfRequest {
    documentId: string;
}

export interface DeleteDropZoneFilesRequest {
    ids?: Array<string>;
}

export interface DownloadDocumentFromCounselorDropZoneRequest {
    documentId: string;
}

export interface GetCounselorDocumentPreviewRequest {
    documentId: string;
}

export interface MergeDropZoneFilesRequest {
    mergeCounselorDocumentsRequest: MergeCounselorDocumentsRequest;
}

export interface RenameDocumentInCounselorDropZoneRequest {
    documentId: string;
    renameDocumentRequest: RenameDocumentRequest;
}

export interface UploadDocumentToCounselorDropZoneRequest {
    convertToPdf?: boolean;
}

/**
 * CounselorDocumentsApi - interface
 * 
 * @export
 * @interface CounselorDocumentsApiInterface
 */
export interface CounselorDocumentsApiInterface {
    /**
     * 
     * @param {string} documentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CounselorDocumentsApiInterface
     */
    convertDocumentInCounselorDropZoneToPdfRaw(requestParameters: ConvertDocumentInCounselorDropZoneToPdfRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    convertDocumentInCounselorDropZoneToPdf(requestParameters: ConvertDocumentInCounselorDropZoneToPdfRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @param {Array<string>} [ids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CounselorDocumentsApiInterface
     */
    deleteDropZoneFilesRaw(requestParameters: DeleteDropZoneFilesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>>;

    /**
     */
    deleteDropZoneFiles(requestParameters: DeleteDropZoneFilesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>>;

    /**
     * 
     * @param {string} documentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CounselorDocumentsApiInterface
     */
    downloadDocumentFromCounselorDropZoneRaw(requestParameters: DownloadDocumentFromCounselorDropZoneRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FileStreamResult>>;

    /**
     */
    downloadDocumentFromCounselorDropZone(requestParameters: DownloadDocumentFromCounselorDropZoneRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FileStreamResult>;

    /**
     * 
     * @param {string} documentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CounselorDocumentsApiInterface
     */
    getCounselorDocumentPreviewRaw(requestParameters: GetCounselorDocumentPreviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FileStreamResult>>;

    /**
     */
    getCounselorDocumentPreview(requestParameters: GetCounselorDocumentPreviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FileStreamResult>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CounselorDocumentsApiInterface
     */
    getDocumentsFromCounselorDropZoneRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<DocumentResponse>>>;

    /**
     */
    getDocumentsFromCounselorDropZone(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<DocumentResponse>>;

    /**
     * 
     * @param {MergeCounselorDocumentsRequest} mergeCounselorDocumentsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CounselorDocumentsApiInterface
     */
    mergeDropZoneFilesRaw(requestParameters: MergeDropZoneFilesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MergeCounselorDocumentsResponse>>;

    /**
     */
    mergeDropZoneFiles(requestParameters: MergeDropZoneFilesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MergeCounselorDocumentsResponse>;

    /**
     * 
     * @param {string} documentId 
     * @param {RenameDocumentRequest} renameDocumentRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CounselorDocumentsApiInterface
     */
    renameDocumentInCounselorDropZoneRaw(requestParameters: RenameDocumentInCounselorDropZoneRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    renameDocumentInCounselorDropZone(requestParameters: RenameDocumentInCounselorDropZoneRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @param {boolean} [convertToPdf] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CounselorDocumentsApiInterface
     */
    uploadDocumentToCounselorDropZoneRaw(requestParameters: UploadDocumentToCounselorDropZoneRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DocumentResponse>>;

    /**
     */
    uploadDocumentToCounselorDropZone(requestParameters: UploadDocumentToCounselorDropZoneRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DocumentResponse>;

}

/**
 * 
 */
export class CounselorDocumentsApi extends runtime.BaseAPI implements CounselorDocumentsApiInterface {

    /**
     */
    async convertDocumentInCounselorDropZoneToPdfRaw(requestParameters: ConvertDocumentInCounselorDropZoneToPdfRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['documentId'] == null) {
            throw new runtime.RequiredError(
                'documentId',
                'Required parameter "documentId" was null or undefined when calling convertDocumentInCounselorDropZoneToPdf().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/counselor/documents/{documentId}/convert-to-pdf`;
        urlPath = urlPath.replace(`{${"documentId"}}`, encodeURIComponent(String(requestParameters['documentId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async convertDocumentInCounselorDropZoneToPdf(requestParameters: ConvertDocumentInCounselorDropZoneToPdfRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.convertDocumentInCounselorDropZoneToPdfRaw(requestParameters, initOverrides);
    }

    /**
     */
    async deleteDropZoneFilesRaw(requestParameters: DeleteDropZoneFilesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>> {
        const queryParameters: any = {};

        if (requestParameters['ids'] != null) {
            queryParameters['ids'] = requestParameters['ids'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/counselor/documents`;

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async deleteDropZoneFiles(requestParameters: DeleteDropZoneFilesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>> {
        const response = await this.deleteDropZoneFilesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async downloadDocumentFromCounselorDropZoneRaw(requestParameters: DownloadDocumentFromCounselorDropZoneRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FileStreamResult>> {
        if (requestParameters['documentId'] == null) {
            throw new runtime.RequiredError(
                'documentId',
                'Required parameter "documentId" was null or undefined when calling downloadDocumentFromCounselorDropZone().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/counselor/documents/{documentId}`;
        urlPath = urlPath.replace(`{${"documentId"}}`, encodeURIComponent(String(requestParameters['documentId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FileStreamResultFromJSON(jsonValue));
    }

    /**
     */
    async downloadDocumentFromCounselorDropZone(requestParameters: DownloadDocumentFromCounselorDropZoneRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FileStreamResult> {
        const response = await this.downloadDocumentFromCounselorDropZoneRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getCounselorDocumentPreviewRaw(requestParameters: GetCounselorDocumentPreviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FileStreamResult>> {
        if (requestParameters['documentId'] == null) {
            throw new runtime.RequiredError(
                'documentId',
                'Required parameter "documentId" was null or undefined when calling getCounselorDocumentPreview().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/counselor/documents/{documentId}/preview`;
        urlPath = urlPath.replace(`{${"documentId"}}`, encodeURIComponent(String(requestParameters['documentId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FileStreamResultFromJSON(jsonValue));
    }

    /**
     */
    async getCounselorDocumentPreview(requestParameters: GetCounselorDocumentPreviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FileStreamResult> {
        const response = await this.getCounselorDocumentPreviewRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getDocumentsFromCounselorDropZoneRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<DocumentResponse>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/counselor/documents`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(DocumentResponseFromJSON));
    }

    /**
     */
    async getDocumentsFromCounselorDropZone(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<DocumentResponse>> {
        const response = await this.getDocumentsFromCounselorDropZoneRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async mergeDropZoneFilesRaw(requestParameters: MergeDropZoneFilesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MergeCounselorDocumentsResponse>> {
        if (requestParameters['mergeCounselorDocumentsRequest'] == null) {
            throw new runtime.RequiredError(
                'mergeCounselorDocumentsRequest',
                'Required parameter "mergeCounselorDocumentsRequest" was null or undefined when calling mergeDropZoneFiles().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/counselor/documents/merge`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MergeCounselorDocumentsRequestToJSON(requestParameters['mergeCounselorDocumentsRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MergeCounselorDocumentsResponseFromJSON(jsonValue));
    }

    /**
     */
    async mergeDropZoneFiles(requestParameters: MergeDropZoneFilesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MergeCounselorDocumentsResponse> {
        const response = await this.mergeDropZoneFilesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async renameDocumentInCounselorDropZoneRaw(requestParameters: RenameDocumentInCounselorDropZoneRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['documentId'] == null) {
            throw new runtime.RequiredError(
                'documentId',
                'Required parameter "documentId" was null or undefined when calling renameDocumentInCounselorDropZone().'
            );
        }

        if (requestParameters['renameDocumentRequest'] == null) {
            throw new runtime.RequiredError(
                'renameDocumentRequest',
                'Required parameter "renameDocumentRequest" was null or undefined when calling renameDocumentInCounselorDropZone().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/counselor/documents/{documentId}/rename`;
        urlPath = urlPath.replace(`{${"documentId"}}`, encodeURIComponent(String(requestParameters['documentId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: RenameDocumentRequestToJSON(requestParameters['renameDocumentRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async renameDocumentInCounselorDropZone(requestParameters: RenameDocumentInCounselorDropZoneRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.renameDocumentInCounselorDropZoneRaw(requestParameters, initOverrides);
    }

    /**
     */
    async uploadDocumentToCounselorDropZoneRaw(requestParameters: UploadDocumentToCounselorDropZoneRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DocumentResponse>> {
        const queryParameters: any = {};

        if (requestParameters['convertToPdf'] != null) {
            queryParameters['convertToPdf'] = requestParameters['convertToPdf'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/counselor/documents`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DocumentResponseFromJSON(jsonValue));
    }

    /**
     */
    async uploadDocumentToCounselorDropZone(requestParameters: UploadDocumentToCounselorDropZoneRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DocumentResponse> {
        const response = await this.uploadDocumentToCounselorDropZoneRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
